import { Field } from '#/components/Form/Field/Field';
import { Input } from '#/components/Input/Input';

type Props = {
  qaId?: string;
  name: string;
  label?: string;
  description?: string;
  placeholder?: string;
  id?: string;
  disabled?: boolean;
};

export function RequestedURLUserField({
  qaId,
  name,
  label,
  description,
  disabled,
  id,
  placeholder,
}: Props) {
  const subName = `${name}.url`;

  return (
    <Field
      customErrorMatch={(errors) => errors[name] ?? errors[subName]}
      name={name}
      label={label}
      description={description}
      renderInput={({ value, qaId: fieldQaId, updateValue }) => (
        <Input
          inputProps={{
            name,
            disabled,
            id,
            placeholder,
            qaId: `${qaId ?? fieldQaId}-hidden-input`,
            value: value ? value.url : '',
            type: 'text',
            onChange: (e) => {
              const v = e.target.value;

              updateValue(
                v
                  ? {
                      type: 'URL',
                      url: v,
                    }
                  : null,
              );
            },
          }}
        />
      )}
    />
  );
}
